import { Checkbox } from '@mui/material';
import { DisplayColumnDef } from '@tanstack/react-table';
import { memo } from 'react';

import { HeaderCheckbox } from '@work4all/components/lib/dataDisplay/basic-table/components/header/components/header-checkbox/HeaderCheckbox';
import {
  SELECT_BOX_MARKER,
  SELECTION_COLUMN_ID,
} from '@work4all/components/lib/dataDisplay/basic-table/utils/makeRowsSelectable';

import { Work4AllEntity } from '@work4all/models/lib/additionalEnums/Work4AllEntity.entity';

import { UserIconCell } from './cell-renderer/userIconCell';
import { OBJECT_LOCK_COLUMN_ID } from './generic-column/GenericColumns';
import { wrapV7Cell } from './wrap-v7-cell';

const MemoizedCheckbox = memo(Checkbox);
const MemoizedHeaderCheckbox = memo(HeaderCheckbox);

export const SelectionColumn: DisplayColumnDef<any, unknown> = {
  id: SELECTION_COLUMN_ID,

  minSize: 48,
  size: 48,
  maxSize: 48,
  enablePinning: true,

  header: (info) => {
    return (
      <div>
        <MemoizedHeaderCheckbox
          checked={info.table.getIsAllRowsSelected()}
          indeterminate={info.table.getIsSomeRowsSelected()}
          onChange={info.table.getToggleAllRowsSelectedHandler()}
        />
      </div>
    );
  },
  // The cell can use the individual row's getToggleRowSelectedProps method
  // to the render a checkbox
  cell: (info) => {
    const attr = { [`data-${SELECT_BOX_MARKER}`]: true };
    return (
      <div {...attr}>
        <MemoizedCheckbox
          checked={info.row.getIsSelected()}
          indeterminate={info.row.getIsSomeSelected()}
          readOnly
          onChange={(e) => {
            const current = info.table.getState().rowSelection;
            const result = {};
            Object.keys(current).forEach((key) => {
              if (key === info.row.id) {
                if (!e.target.checked) {
                  result[key] = true;
                  return;
                }
              } else {
                result[key] = current[key];
              }
            });
            info.table.setRowSelection(result);
          }}
        />
      </div>
    );
  },
};

export const ObjectLockColumn: DisplayColumnDef<any, unknown> = {
  id: OBJECT_LOCK_COLUMN_ID,
  header: '',
  accessorKey: 'objectLock',

  cell: wrapV7Cell(UserIconCell),
  cellParams: {
    locked: true,
  },
  size: 43,
  filterParams: {
    entity: '',
    entityDE: '',
    multiple: true,
  },
  enableResizing: false,
  enableColumnFilter: false,
  enableGrouping: false,
} as DisplayColumnDef<Work4AllEntity, unknown>;
